import React from 'react';
import './Footer.css';
import { FaInstagram, FaFacebookF, FaLinkedinIn } from 'react-icons/fa';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="footer">
      {/* Optional CTA strip (looks like the slick example) */}
      <div className="footer-cta">
        <h2>Ready to level up your brand?</h2>
        <a href="#contact" className="footer-cta-btn">Get a Free Quote</a>
      </div>

      <div className="footer-inner">
        <div className="footer-grid">
          {/* Brand */}
          <div className="footer-brand">
            <h3>Shyne Graphics Corp</h3>
            <p>Designing brands that shine.</p>
          </div>

          {/* Nav */}
          <nav className="footer-nav" aria-label="Footer navigation">
            <h4>Explore</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </nav>

          {/* Social */}
          <div className="footer-social">
            <h4>Follow Us</h4>
            <div className="social-icons">
              <a
                className="social-btn instagram"
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>

              <a
                className="social-btn facebook"
                href="https://www.facebook.com/profile.php?id=61576367075453"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <FaFacebookF />
              </a>

              <a
                className="social-btn linkedin"
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <FaLinkedinIn />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Shyne Graphics Corp. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
